import React, { useState } from "react";
import StepperDUC from "../StepperDUC";
import {
    stepLabels,
    stepLabelsDeclinedCommittee,
    stepLabelsDeclinedOfficial,
    stepLabelsDeclinedRecipient
} from "../DUCpage";
import { Stack, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { useUserInfoQuery } from "../../../api/userApiSlice";


interface props {
    ducData: any
    declinedAIAN: boolean
    expiredAIAN: boolean
    activeStepAIAN: number
    index: number
}


const AIANBlockSteper = (props: props) => {
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });

    const ducDataGen = ducDataObject?.GENERAL?.[0]

    const [hide, setHide] = useState(false)

    const handleClick = () => {
        setHide(!hide);
    }

    return (
        <Stack>
            {ducDataGen?.status === 'Approved' &&
                <Stack flexDirection="row" onClick={handleClick}
                    sx={{ "&:hover": { cursor: "pointer" } }}>
                    {hide && <PlayArrowIcon/>}
                    {!hide && <ArrowDropDownIcon fontSize="large"/>}
                    <Typography fontSize="16px" fontWeight="400">
                        Application
                    </Typography>
                </Stack>
            }

            {ducDataGen?.status === 'Approved' && props.ducData?.status !== 'Approved' && !props.declinedAIAN && !hide &&
                !props.expiredAIAN &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabels} />}

            {ducDataGen.status === 'Approved' && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Official" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedOfficial} />}

            {ducDataGen?.status === 'Approved' && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Committee" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedCommittee} />}

            {ducDataGen?.status === 'Approved' && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Submitter" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedRecipient} />}

            {(props.ducData?.status  === 'Approved' || props.ducData?.status  === 'Expired') && !hide &&
                <Stack flexDirection="row" gap={3}>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Submission date
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSubmitted}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Expiration date
                            </Typography>
                            <Typography>
                                {props.ducData?.expiresOn}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Authorized Institutional Business official email
                            </Typography>
                            <Typography>
                                {props.ducData?.signingAuthorityEmail}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Approval by official
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSignedOfficial || "Not signed yet"}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                NBDC Data Access committee email
                            </Typography>
                            <Typography>
                                {props.ducData?.committeeEmail}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Approval by committee
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSignedCommittee || "Not signed yet"}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>}
        </Stack>
    )

}

export default AIANBlockSteper